export default "__VITE_ASSET__C7doQf53__"